import {connect, useDispatch, useSelector} from 'react-redux'
import * as rest from '../../services'
import { showErrorToast, showSuccessToast } from '../../state/toasts'
import * as ReactBootstrap from 'react-bootstrap'
import { Badge, Tab, Tabs } from 'react-bootstrap'
import {DeliveryPrint, DeliveryPrintReport, TicketPrintReport} from './prints'
import { ESignaturePane } from '../ESignature'
import { TicketComments } from './TicketComments'
import { TicketVouchers } from './TicketVouchers'
import { TicketLoanerRecords } from './TicketLoanerRecords'
import { TicketOrderLines } from './TicketOrderLines'
import { TicketNonSerializedOrderLines } from './TicketNonSerializedOrderLines'
import { StatusUpdate } from './StatusUpdate'
import { UpdateTicketAssignment } from './UpdateTicketAssignment'
import { CheckCanPrintDeliveryReport } from './CheckCanPrintDeliveryReport'
import { UpdateDeliveryInfo } from './UpdateDeliveryInfo'
import GSXRepairTypeInfo from './forms/GSXRepairTypeInfo'

import { TicketComponentIssues } from './TicketComponentIssues'

import GSXInformationList from './GSXInformationList'
import Communication from './Communication'
import ChangeLogs from './ChangeLogs'
import { TicketSavedQnA } from './TicketSavedQnA'
import * as components from '../../components'
import {RepairFlags} from "./RepairFlagsForm";
import GSXClassificationInfo from "./forms/GSXClassificationInfo";
import {RepairCreateButton} from "../Repairs";
import PartRequests from "./PartRequests";
import Attachments from "./Attachments";
import {ICONS, PrintHOC, Slider} from "../../components";
import DeviceForm from "./forms/DeviceForm";
import CustomerForm from "./forms/CustomerForm";
import IssueForm from "./forms/IssueForm";
import {formValueSelector} from "redux-form";
import { BuybackTab } from './BuybackTab/BuybackTab'
import React from "react";
import {InwardCommunication} from "./Communication/InwardCommunication";
import {
    ForeignDeviceWaiverSlider,
    IphoneCrossBorderFormSlider, WatchReleaseOfLiabilityFormSlider,
    IPhone14SeriesDisclaimerFormSlider,
} from "./DisclaimerForms/DisclaimerFormsSlider";
import Estimations from "./Estimations";
const SUPERUSER = 'SUPERUSER'
const Privileged = 'Privileged'.toUpperCase()

export const TicketUpdateTabs = ({
  ticket,
  onTicketUpdate,
  activeKey,
  onSelect,
  unit_parts,
}) => {
  const dispatch = useDispatch()


  const onInlineTicketUpdate = (ticket) => {
    const payload = {
      ...ticket,
      device: ticket.device.url,
      customer: ticket.customer.url,
      organization: ticket.organization.url,
    }
    const promise =
      ticket && ticket.url
        ? new rest.TicketService(ticket.url).makePutRequest(payload)
        : new rest.TicketService().makePostRequest(payload)
    promise
      .then((response) => {
        onTicketUpdate({...response})
        dispatch(
          showSuccessToast('Success', 'Ticket Information has been updated.')
        )
      })
      .catch((errors) => {
        dispatch(
          showErrorToast(
            'Error on Ticket Information update',
            errors.response.data
          )
        )
      })
  }
  const onInlineDeviceUpdate = (device) => {
    const promise = new rest.DeviceService(device.url).makePutRequest(device)
    promise
      .then((response) => {

        const updatedTicket = {
          ...ticket,
          device: response
        };
        onTicketUpdate(updatedTicket)
        dispatch(
          showSuccessToast('Success', 'Device Information has been updated.')
        )
      })
      .catch((errors) => {
        console.log(errors)
        dispatch(
          showErrorToast(
            'Error on Device Information update',
            errors.response.data
          )
        )
      })
  }
  const onInlineCustomerUpdate = (customer) => {
    const promise = new rest.CustomerService(customer.url).makePutRequest(
      customer
    )
    promise
      .then((response) => {
        onTicketUpdate({...ticket,customer:response})
        dispatch(
          showSuccessToast('Success', 'Customer Information has been updated.')
        )
      })
      .catch((errors) => {
        dispatch(
          showErrorToast(
            'Error on Customer Information  update',
            errors.response.data
          )
        )
      })
  }
  const DeviceFormWithData = connect((state) => ({
    initialValues: ticket.device,
  }))(DeviceForm)
  const CustomerFormWithData = connect((state) => ({
    initialValues: ticket.customer,
  }))(CustomerForm)

  let TicketFormWithData = connect((state) => ({
    initialValues: ticket,
  }))(IssueForm)
  const selector = formValueSelector('ticket-form')

  TicketFormWithData = connect((state) => {
    const unit_part_reports = selector(state, 'unit_part_reports')
    return {
      unit_part_reports,
    }
  })(TicketFormWithData)


    const { user } = useSelector((state) => state.auth)
    const canPrint = user.role.toUpperCase() === SUPERUSER.toUpperCase()
        || user.role.toUpperCase() === Privileged.toUpperCase()
        || ticket.organization.manager===user.url
    const canViewChangeLogs = user.role.toUpperCase() === SUPERUSER.toUpperCase()
        || user.role.toUpperCase() === Privileged.toUpperCase()
    const temp = <>
    <span className="me-3"><InwardCommunication ticket={ticket} /></span>
  <span className="me-3"> <Slider  sliderWidth={"75vw"}
                title={
                  <>
                    <span className="pe-3">{ICONS.EDIT} </span>
                    <span className="pe-3">Edit Device</span>
                  </>
                }
                size="sm"
                header={
                  <>
                    <span className="pe-3">{ICONS.EDIT} </span>
                    <span className="pe-3">Edit Device</span>
                  </>
                }
              >
                <DeviceFormWithData onSubmit={onInlineDeviceUpdate} />
  </Slider></span>
  <span className="me-3">   <Slider  sliderWidth={"75vw"}
                title={
                  <>
                    <span className="pe-3">{ICONS.EDIT} </span>
                    <span className="pe-3">Edit Customer</span>
                  </>
                }
                size="sm"
                header={
                  <>
                    <span className="pe-3">{ICONS.EDIT} </span>
                    <span className="pe-3">Edit Customer</span>
                  </>
                }
              >
                <CustomerFormWithData
                  editMode={true}
                  onSubmit={onInlineCustomerUpdate}
                />
  </Slider></span>
    <span className="me-3"><Slider
            sliderWidth={"75vw"}
            title={
              <>
                <span className="pe-3">{ICONS.EDIT}</span>
                <span>Edit Ticket</span>
              </>
            }
            header={
              <>
                <span className="pe-3">{ICONS.EDIT}</span>
                <span>Edit Ticket</span>
              </>
            }
          >
            <TicketFormWithData
              editMode={true}
              onSubmit={onInlineTicketUpdate}
            />
  </Slider></span>
   <span className="me-3">   <ESignaturePane
            id={ticket.id}
            type="ticket"
            guid={ticket.guid}
            code={ticket.reference_number}
   ></ESignaturePane></span>

        <span className="me-3"><Slider
            sliderWidth={"75vw"}
            title={
              <>
                   <span>{ICONS.COMMENTS}</span>
              </>
            }
            header={
              <>
                <span className="pe-3">{ICONS.COMMENTS}</span>
               <span>Comments</span>
              </>
            }
          >
         <TicketComments ticket={ticket} onTicketUpdate={onTicketUpdate} />
  </Slider></span>



  </>
  const TicketPrint = PrintHOC(TicketPrintReport,temp)
  return (
    <Tabs
      activeKey={activeKey}
      onSelect={onSelect}
      id="uncontrolled-tab-example"
    >
      <Tab
        eventKey="jobsheet"
        title={<span className="text-dark">Ticket</span>}
      >
        <TicketPrint
            disabled={!canPrint}
          onInlineDeviceUpdate={onInlineDeviceUpdate}
          onInlineCustomerUpdate={onInlineCustomerUpdate}
          onInlineTicketUpdate={onInlineTicketUpdate}
          ticket={ticket}

        >

        </TicketPrint>
      </Tab>
      <Tab
        eventKey="comments"
        title={
          <>
            <span
              className={ticket?.comments?.length ? 'text-success' : 'text-dark'}
            >
              Comments
            </span>
            <Badge
              className="ml-1"
              bg={ticket?.comments?.length ? 'success' : 'warning'}
            >
              {ticket?.comments?.length}
            </Badge>
          </>
        }
      >
        <TicketComments ticket={ticket} onTicketUpdate={onTicketUpdate} />
      </Tab>
      <Tab
        eventKey="vouchers"
        title={
          <>
            <span
              className={ticket?.vouchers?.length ? 'text-success' : 'text-dark'}
            >
              Vouchers
            </span>
            <Badge
              className="ml-1"
              bg={ticket?.vouchers?.length ? 'success' : 'warning'}
            >
              {ticket?.vouchers?.length}
            </Badge>
          </>
        }
      >
        <TicketVouchers ticket={ticket} onTicketUpdate={onTicketUpdate} />
      </Tab>
              <Tab
        eventKey="disclaimers"
         title={

             <span
                 className={'text-dark'}
             >
              Disclaimers
            </span>
         }


      >
                  <ReactBootstrap.Row>
                      <ReactBootstrap.Col style={{padding:"30px"}} xs={12}>
                           <ForeignDeviceWaiverSlider ticket={ticket} onTicketUpdate={onTicketUpdate} />
                      </ReactBootstrap.Col>
                       <ReactBootstrap.Col style={{padding:"30px"}} xs={12}>
                           <IphoneCrossBorderFormSlider ticket={ticket} onTicketUpdate={onTicketUpdate} />
                      </ReactBootstrap.Col>
                       <ReactBootstrap.Col style={{padding:"30px"}} xs={12}>
                            <WatchReleaseOfLiabilityFormSlider ticket={ticket} onTicketUpdate={onTicketUpdate} />
                      </ReactBootstrap.Col>
                       <ReactBootstrap.Col style={{padding:"30px"}} xs={12}>
                            <IPhone14SeriesDisclaimerFormSlider ticket={ticket} onTicketUpdate={onTicketUpdate} />
                      </ReactBootstrap.Col>


                  </ReactBootstrap.Row>



      </Tab>


      <Tab
        eventKey="inventory"
        title={
          <>
            <span
              className={
                ticket?.order_lines?.length ||
                ticket?.loaner_records?.length ||
                ticket?.serializable_order_lines?.length
                  ? 'text-success'
                  : 'text-dark'
              }
            >
              Inventory
            </span>
            <Badge
              className="ml-1"
              bg={ticket?.loaner_records?.length ? 'success' : 'warning'}
            >
              {ticket?.loaner_records?.length}
            </Badge>
            <Badge
              className="ml-1"
              bg={ticket?.order_lines?.length ? 'success' : 'warning'}
            >
              {ticket?.order_lines?.length}
            </Badge>
            <Badge
              className="ml-1"
              bg={
                ticket?.serializable_order_lines?.length ? 'success' : 'warning'
              }
            >
              {ticket?.serializable_order_lines?.length}
            </Badge>
          </>
        }
      >
        <TicketLoanerRecords ticket={ticket} onTicketUpdate={onTicketUpdate} />
        <TicketOrderLines ticket={ticket} onTicketUpdate={onTicketUpdate} />
        <TicketNonSerializedOrderLines
          ticket={ticket}
          onTicketUpdate={onTicketUpdate}
        />
      </Tab>
      <Tab
        eventKey="update"
        title={
          <>
            <span className={ticket.closed_by ? 'text-success' : 'text-dark'}>
              Status
            </span>
            <Badge
              className="ml-1"
              bg={ticket.closed_by ? 'success' : 'warning'}
            >
              {ticket.status}
            </Badge>
          </>
        }
      >
        <StatusUpdate ticket={ticket} onTicketUpdate={onTicketUpdate} />
        <UpdateTicketAssignment
          ticket={ticket}
          onTicketUpdate={onTicketUpdate}
        />
      </Tab>
      <Tab
        eventKey="update_delivery"
        title={
          <>
            <span
              className={
                ticket.can_print_delivery_report &&
                ticket.can_print_delivery_report.flag
                  ? 'text-success'
                  : 'text-dark'
              }
            >
              Delivery
            </span>
          </>
        }
      >
        <>
          <CheckCanPrintDeliveryReport
            ticket={ticket}
            onCheck={onTicketUpdate}
          />

          <div style={{"display":"contents"}} className="mt-5">




            {!ticket.can_print_delivery_report.flag && (
              <DeliveryPrintReport disabled={!canPrint} ticket={ticket}>
                  <div style={{"display":"flex","float":"right","gap":"12px"}} className="mt-5 mr-3">
                <span className="mr-3">
                  {ticket.delivery && (
                    <ESignaturePane
                      id={ticket.delivery.id}
                      guid={ticket.delivery.guid}
                      type="delivery"
                      code={ticket.reference_number}
                    ></ESignaturePane>
                  )}

                </span>

                <UpdateDeliveryInfo
                  ticket={ticket}
                  onTicketUpdate={onTicketUpdate}
                />
                  </div>

              </DeliveryPrintReport>
            )}

            {ticket.can_print_delivery_report.flag && (
              <DeliveryPrint disabled={!canPrint} ticket={ticket}>
                <span className="mr-3">
                  {ticket.delivery && (
                    <ESignaturePane
                      id={ticket.delivery.id}
                      guid={ticket.delivery.guid}
                      type="delivery"
                      code={ticket.reference_number}
                    ></ESignaturePane>
                  )}
                </span>
                <UpdateDeliveryInfo
                  unit_parts={unit_parts}
                  ticket={ticket}
                  onTicketUpdate={onTicketUpdate}
                />
              </DeliveryPrint>
            )}
          </div>
        </>
      </Tab>
      <Tab
        eventKey="gsx_information"
        title={
          <>
            <span
              className={
                ticket?.gsx_information?.length ? 'text-success' : 'text-dark'
              }
            >
              GSX information
            </span>
            <Badge
              className="ml-1"
              bg={ticket?.gsx_information?.length ? 'success' : 'warning'}
            >
              {ticket?.gsx_information?.length}
            </Badge>
          </>
        }
      >
            <ReactBootstrap.Row>

          <ReactBootstrap.Col className={"text-end"} pt={3} xs={12}>
            <components.Slider
              header={
                <span>
                  {components.ICONS.PLUS} Proposed Data For GSX Repair
                  {ticket.reference_number}
                </span>
              }
              title={
                <span className="">
                  {components.ICONS.PLUS} Create GXS Repair
                </span>
              }
            >
              <RepairCreateButton ticket={ticket} />
            </components.Slider>
          </ReactBootstrap.Col>
        </ReactBootstrap.Row>
        <GSXRepairTypeInfo ticket={ticket} onTicketUpdate={onTicketUpdate}  />
        <GSXClassificationInfo ticket={ticket} onTicketUpdate={onTicketUpdate} />
        <TicketComponentIssues
          ticket={ticket}
          onTicketUpdate={onTicketUpdate}
        />
        <PartRequests
          ticket={ticket}
          onUpdate={onTicketUpdate}
        />
        <TicketSavedQnA ticket={ticket} onTicketUpdate={onTicketUpdate} />
        <RepairFlags ticket={ticket} onTicketUpdate={onTicketUpdate} />

        <GSXInformationList ticket={ticket} onTicketUpdate={onTicketUpdate} />

      </Tab>
      <Tab
        eventKey="customer_communication"
        title={<span className="text-dark">Communication</span>}
      >
        <Communication ticket={ticket} onTicketUpdate={onTicketUpdate} />
      </Tab>
      <Tab
        eventKey="file_upload"
        title={<span className="text-dark">Attachments  <Badge
              className="ml-1"
              bg={ticket.uploaded_contents.length ? 'success' : 'warning'}
            >
              {ticket.uploaded_contents.length}
            </Badge></span>}
      >
        <Attachments ticket={ticket} onTicketUpdate={onTicketUpdate} />
      </Tab>
       <Tab
        eventKey="estimations"
        title={<span className="text-dark">Estimations  <Badge
              className="ml-1"
              bg={ticket.quotation_records.length ? 'success' : 'warning'}
            >
              {ticket.quotation_records.length}
            </Badge></span>}
      >
        <Estimations ticket={ticket}  onUpdate={onTicketUpdate} />
      </Tab>
        {canViewChangeLogs && <Tab
        eventKey="change_log"
        title={
          <span className="text-dark">
            Change Log
            <Badge
              className="ml-1"
              bg={ticket.change_logs.length ? 'success' : 'warning'}
            >
              {ticket.change_logs.length}
            </Badge>
          </span>
        }
      >
        <ChangeLogs ticket={ticket} />
      </Tab>}
      <Tab
        eventKey="buyback_emi"
        title={<span className="text-dark">Buyback / EMI
        <Badge
              className="ml-1"
              bg={ticket?.buyback_emi_records?.length ? 'success' : 'warning'}
            >
              {ticket?.buyback_emi_records?.length}
            </Badge>
        </span>}
      >
        <BuybackTab ticket={ticket} />
      </Tab>
    </Tabs>
  )
}
